import Vue from 'vue'
import vuetify from '@/plugins/vuetify'
import App from './App.vue'
import store from './store'
import router from './router'
import i18n from './i18n'
import DateTimeLocal from './filters/DateTimeLocal'
//import { DateTime } from "luxon";

// Import the Auth0 configuration and plugin
import '@mdi/font/css/materialdesignicons.css'
import { domain, clientId, audience } from '@/auth_config.json';
import { Auth0Plugin } from '@/auth/auth0-plugin.js';

Vue.use(Auth0Plugin, {
  domain,
  clientId,
  audience,
  onRedirectCallback: (appState: any) => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname,
    );
  },
});


Vue.config.productionTip = false

Vue.filter('DateTimeLocal', DateTimeLocal );

new Vue({
  vuetify,
  store,
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
